module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_h_dark.c2aa8a0f.svg";